
    var riot = require('riot')
    //src: starling/src/tags/nodes.html
riot.tag2('nodes',
  '<div class="top-level-nodes" ref="topNodes"> <node each="{this.store.topNodes()}" instance="{this}" canvas="{parent.canvas}" operation="{parent.operation}"></node> </div>',
  '',
  '', function(opts) {
'use strict';

var _this = this;

this.canvas = opts.canvas;
this.store = opts.store;
this.canvas.nodesTag = this;

this.on('mount', function () {
    // avoid running postInitialization if we have no nodes in the map
    if (_this.store.topNodes().length == 0) {
        _this.canvas.postInitializationComplete = true;
    }
});
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('nodes')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/nodes.html
// module id = 611
// module chunks = 0